export default __webpack_public_path__ + "static/media/interface_statistics-hover.3cdba847.svg";